import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

import { IconTypes } from 'src/types';

/**
 * @internal
 */
export type RejectProps = SvgIconProps;

/**
 * @internal
 */
export const Reject: FC<RejectProps> = props => (
  <SvgIcon aria-label={IconTypes.REJECT} {...props}>
    <g id="gk93D8BWZvo94r1R7-J4e" transform="matrix(1 0 0 1 12 12)">
      <path
        d="M 12 0 C 5.4 0 0 5.4 0 12 C 0 18.6 5.4 24 12 24 C 18.6 24 24 18.6 24 12 C 24 5.4 18.6 0 12 0 z M 17.25 15.15 L 15.15 17.25 L 12 14.1 L 8.85 17.25 L 6.75 15.15 L 9.9 12 L 6.75 8.85 L 8.85 6.75 L 12 9.9 L 15.15 6.75 L 17.25 8.85 L 14.1 12 z"
        strokeLinecap="round"
        transform=" translate(-12, -12)"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </SvgIcon>
);
